import { preCarrierCode } from '../constants/fields';
import { type State } from '../types';
import { getFieldFromState } from './getFieldFromState';

export const isFieldEnabled = (state: State, code: number, value: number) =>
  Number(getFieldFromState(state, code)?.value) === value;

export const isCarrierFieldEnabled = (state: State) => isFieldEnabled(state, preCarrierCode, 1);
